import { useRef } from 'react';

/**
 * Runs a Save/Create handler once per click burst.
 *
 * The button is disabled by the mutation's pending flag, but that flag reaches
 * React a tick after `mutate` (TanStack Query notifies on a 0ms timer), so a
 * double-click — or a scripted triple-click — landed two or three POSTs
 * before the button greyed out, and the extra ones failed with an error toast
 * over an order that had in fact been created. The latch closes on the first
 * call and reopens on the next macrotask, queued after the mutation's own
 * notification: by then the pending render has committed and the disabled
 * button holds the line.
 */
export function useSubmitOnce() {
  const latched = useRef(false);
  return (run: () => void) => {
    if (latched.current) return;
    latched.current = true;
    try {
      run();
    } finally {
      setTimeout(() => {
        latched.current = false;
      }, 0);
    }
  };
}
